"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PUBLIC_URL = exports.SERVER_URL = void 0;
var SERVER_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_DEPLOYED_SERVER_URL : "".concat(process.env.REACT_APP_SERVER_URL, ":").concat(process.env.REACT_APP_SERVER_PORT);
exports.SERVER_URL = SERVER_URL;
var PUBLIC_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_DEPLOYED_PUBLIC_URL : process.env.REACT_APP_PUBLIC_URL;
exports.PUBLIC_URL = PUBLIC_URL;